module.exports = __webpack_public_path__ + "static/media/prof-fake.0a724c2c.jpg";